import { elapsed, timeStampNow } from '@datadog/browser-core';
import { trackCumulativeLayoutShift } from './trackCumulativeLayoutShift';
import { trackInteractionToNextPaint } from './trackInteractionToNextPaint';
import { trackLoadingTime } from './trackLoadingTime';
import { trackScrollMetrics } from './trackScrollMetrics';
export function trackCommonViewMetrics(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
  var commonViewMetrics = {};
  var hasManualLoadingTime = false;
  var viewEnded = false;
  var _trackLoadingTime = trackLoadingTime(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
      if (!hasManualLoadingTime) {
        commonViewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
      }
    }),
    stopLoadingTimeTracking = _trackLoadingTime.stop,
    setLoadEvent = _trackLoadingTime.setLoadEvent;
  var _trackScrollMetrics = trackScrollMetrics(configuration, viewStart, function (newScrollMetrics) {
      commonViewMetrics.scroll = newScrollMetrics;
    }),
    stopScrollMetricsTracking = _trackScrollMetrics.stop;
  var _trackCumulativeLayou = trackCumulativeLayoutShift(configuration, viewStart.relative, function (cumulativeLayoutShift) {
      commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
      scheduleViewUpdate();
    }),
    stopCLSTracking = _trackCumulativeLayou.stop;
  var _trackInteractionToNe = trackInteractionToNextPaint(configuration, viewStart.relative, loadingType),
    stopINPTracking = _trackInteractionToNe.stop,
    getInteractionToNextPaint = _trackInteractionToNe.getInteractionToNextPaint,
    setINPViewEnd = _trackInteractionToNe.setViewEnd;
  return {
    stop: function stop() {
      stopLoadingTimeTracking();
      stopCLSTracking();
      stopScrollMetricsTracking();
    },
    stopINPTracking: stopINPTracking,
    setLoadEvent: setLoadEvent,
    setViewEnd: function setViewEnd(viewEndTime) {
      viewEnded = true;
      setINPViewEnd(viewEndTime);
    },
    getCommonViewMetrics: function getCommonViewMetrics() {
      commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
      return commonViewMetrics;
    },
    setLoadingTime: function setLoadingTime(callTimestamp) {
      if (viewEnded) {
        return;
      }
      var loadingTime = elapsed(viewStart.timeStamp, callTimestamp !== null && callTimestamp !== void 0 ? callTimestamp : timeStampNow());
      if (!hasManualLoadingTime) {
        stopLoadingTimeTracking();
      }
      hasManualLoadingTime = true;
      commonViewMetrics.loadingTime = loadingTime;
      scheduleViewUpdate();
    }
  };
}